import config from '../../config';
import { request } from '../../libraries/request'

const upload = (params, token) => {
  //params.set("identifier", parseInt(Math.random()*1000000).toString())
  params.set("identifier", `${process.env.NODE_ENV}_${params.get("identifier")}`)

  console.log('SERVICES::FILES::upload', params, token,);
  return request({
    url: config.BASE_API_URL + config.API.FILES,
    accessToken: token,
    method: 'POST',
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

export default {
  upload,
};
